// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
	position: relative;
	width: 100%;
	height: 50px;
	background: #fff;
	border-bottom: 1px solid #d5d5d5;
	font-size: 16px;
	font-size: 1.6rem;
	/*	overflow: hidden;*/
}

header > .container {
	display: table;
	width: 100%;
	max-height: 51px;
	padding: 0;
	border-collapse: separate;
}


.topbar-left {
	display: table-cell;
	width: 320px;
	max-width: 320px;
	min-width: 275px;
	padding: 0 82px 0 10px;
	vertical-align: middle;
	text-align: center;
	border-collapse: separate;
	max-height: 39px;
}

.logo-container {
	display: inline-block; 
	
	margin-right: 65px;
}
 

.logo {
	display: inline-block;
	margin: 2px 0 1px 0;
	width: auto;
	height: 40px;
}

.title-pane {
	display: table-cell;
	width: 100%;
	min-width: 555px; 
	overflow-x: auto;
	vertical-align: middle;
	overflow: hidden;
	border-collapse: separate;
	text-align: center;

}

.title-pane .document-info {
	font-size: 12px;
	list-style: none;
	padding: 0;
	margin: 0;
	text-align: left;
	display: inline-flex;
}

.title-pane .document-info li {
	margin-right: 20px;
}

.title-pane .document-info li:last-child {
	margin-right: 0;
}

.title-pane .doc-name span {
	font-family: "Roboto", "sans-serif";
	font-weight: 500;
	font-size: 1.4rem;
}

.title-pane .header-ellipsis,
.title-pane .header-ellipsis{
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	display: block;
	max-width: 275px;
}

title-pane .title-columns {
	width: 241px;
	max-width: 241px;
}


.topbar-tools {
	float: right;
	display: table-cell;
	margin: 0;
	width: 320px;
	vertical-align: middle;
	max-height: 40px;
	text-align: center;
} 

.topbar-tools .navbar-right {
	margin-top: 5px; 
    float: none !important;
	display: inline-block;
	margin-left: 15px;
}


.topbar-tools .close-icon {
	width: 30px; 
	height: 32px; 
	float: right;
}

@media screen and (max-width: 1200px) {
	.topbar-left {
		min-width: 235px;
		width: 235px;
		padding-right: 0;
	}

	.logo-container {
		margin-left: 0;
		margin-right: 0;
	}

	.topbar-tools {
		width: 235px;
		min-width: 235px;
		padding-right: 0;
	}


	.topbar-tools .navbar-right {
		margin-left: 0;
	}

	.topbar-tools .close-icon {
		margin-top: -45px;
	}
}


header .nav li a {
	padding: 5px 10px;
	background: transparent;
	/*font-size: 15px;*/
	font-size: 1.2rem;
	font-family: "Roboto", "sans-serif";
	font-weight: 500;
	color: #333;
	text-decoration: none;
}

header .nav li a:hover {
	background: transparent !important;
}

header .nav .open > a, header .nav .open > a:hover, header.nav .open > a:focus, header.nav .open > a:visited {
	background: transparent !important;
	border: 0px;
}

header .nav .dropdown .dropdown-menu a {
	font-weight: 400;
}

header .nav .dropdown .dropdown-menu a:hover {
	background: var(--main-primary) !important;
	color: #fff;
}

header .navbar-nav li a i {
	font-size: 16px;
	font-size: 1.6rem;
}

/*header .header-menu li a:hover {
    color: #799f2c;
}

header .header-menu i {
    font-size: 24px;
}*/
	


@media (max-width: 1200px) {
	.navbar-nav { 
		margin-top: -6px;
	}

}
`, "",{"version":3,"sources":["webpack://./assets/style/partials/header.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,gCAAgC;CAChC,eAAe;CACf,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,gBAAgB;CAChB,UAAU;CACV,yBAAyB;AAC1B;;;AAGA;CACC,mBAAmB;CACnB,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,sBAAsB;CACtB,sBAAsB;CACtB,kBAAkB;CAClB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;;CAErB,kBAAkB;AACnB;;;AAGA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,gBAAgB;CAChB,gBAAgB;CAChB,sBAAsB;CACtB,gBAAgB;CAChB,yBAAyB;CACzB,kBAAkB;;AAEnB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,UAAU;CACV,SAAS;CACT,gBAAgB;CAChB,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mCAAmC;CACnC,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;;CAEC,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;CACvB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,gBAAgB;AACjB;;;AAGA;CACC,YAAY;CACZ,mBAAmB;CACnB,SAAS;CACT,YAAY;CACZ,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,eAAe;IACZ,sBAAsB;CACzB,qBAAqB;CACrB,iBAAiB;AAClB;;;AAGA;CACC,WAAW;CACX,YAAY;CACZ,YAAY;AACb;;AAEA;CACC;EACC,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;;CAEA;EACC,cAAc;EACd,eAAe;CAChB;;CAEA;EACC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;CACjB;;;CAGA;EACC,cAAc;CACf;;CAEA;EACC,iBAAiB;CAClB;AACD;;;AAGA;CACC,iBAAiB;CACjB,uBAAuB;CACvB,mBAAmB;CACnB,iBAAiB;CACjB,mCAAmC;CACnC,gBAAgB;CAChB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;CAClC,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,0CAA0C;CAC1C,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;;;;;;EAME;;;;AAIF;CACC;EACC,gBAAgB;CACjB;;AAED","sourcesContent":["header {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\theight: 50px;\r\n\tbackground: #fff;\r\n\tborder-bottom: 1px solid #d5d5d5;\r\n\tfont-size: 16px;\r\n\tfont-size: 1.6rem;\r\n\t/*\toverflow: hidden;*/\r\n}\r\n\r\nheader > .container {\r\n\tdisplay: table;\r\n\twidth: 100%;\r\n\tmax-height: 51px;\r\n\tpadding: 0;\r\n\tborder-collapse: separate;\r\n}\r\n\r\n\r\n.topbar-left {\r\n\tdisplay: table-cell;\r\n\twidth: 320px;\r\n\tmax-width: 320px;\r\n\tmin-width: 275px;\r\n\tpadding: 0 82px 0 10px;\r\n\tvertical-align: middle;\r\n\ttext-align: center;\r\n\tborder-collapse: separate;\r\n\tmax-height: 39px;\r\n}\r\n\r\n.logo-container {\r\n\tdisplay: inline-block; \r\n\t\r\n\tmargin-right: 65px;\r\n}\r\n \r\n\r\n.logo {\r\n\tdisplay: inline-block;\r\n\tmargin: 2px 0 1px 0;\r\n\twidth: auto;\r\n\theight: 40px;\r\n}\r\n\r\n.title-pane {\r\n\tdisplay: table-cell;\r\n\twidth: 100%;\r\n\tmin-width: 555px; \r\n\toverflow-x: auto;\r\n\tvertical-align: middle;\r\n\toverflow: hidden;\r\n\tborder-collapse: separate;\r\n\ttext-align: center;\r\n\r\n}\r\n\r\n.title-pane .document-info {\r\n\tfont-size: 12px;\r\n\tlist-style: none;\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\ttext-align: left;\r\n\tdisplay: inline-flex;\r\n}\r\n\r\n.title-pane .document-info li {\r\n\tmargin-right: 20px;\r\n}\r\n\r\n.title-pane .document-info li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n\r\n.title-pane .doc-name span {\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-weight: 500;\r\n\tfont-size: 1.4rem;\r\n}\r\n\r\n.title-pane .header-ellipsis,\r\n.title-pane .header-ellipsis{\r\n\toverflow: hidden;\r\n\twhite-space: nowrap;\r\n\ttext-overflow: ellipsis;\r\n\tdisplay: block;\r\n\tmax-width: 275px;\r\n}\r\n\r\ntitle-pane .title-columns {\r\n\twidth: 241px;\r\n\tmax-width: 241px;\r\n}\r\n\r\n\r\n.topbar-tools {\r\n\tfloat: right;\r\n\tdisplay: table-cell;\r\n\tmargin: 0;\r\n\twidth: 320px;\r\n\tvertical-align: middle;\r\n\tmax-height: 40px;\r\n\ttext-align: center;\r\n} \r\n\r\n.topbar-tools .navbar-right {\r\n\tmargin-top: 5px; \r\n    float: none !important;\r\n\tdisplay: inline-block;\r\n\tmargin-left: 15px;\r\n}\r\n\r\n\r\n.topbar-tools .close-icon {\r\n\twidth: 30px; \r\n\theight: 32px; \r\n\tfloat: right;\r\n}\r\n\r\n@media screen and (max-width: 1200px) {\r\n\t.topbar-left {\r\n\t\tmin-width: 235px;\r\n\t\twidth: 235px;\r\n\t\tpadding-right: 0;\r\n\t}\r\n\r\n\t.logo-container {\r\n\t\tmargin-left: 0;\r\n\t\tmargin-right: 0;\r\n\t}\r\n\r\n\t.topbar-tools {\r\n\t\twidth: 235px;\r\n\t\tmin-width: 235px;\r\n\t\tpadding-right: 0;\r\n\t}\r\n\r\n\r\n\t.topbar-tools .navbar-right {\r\n\t\tmargin-left: 0;\r\n\t}\r\n\r\n\t.topbar-tools .close-icon {\r\n\t\tmargin-top: -45px;\r\n\t}\r\n}\r\n\r\n\r\nheader .nav li a {\r\n\tpadding: 5px 10px;\r\n\tbackground: transparent;\r\n\t/*font-size: 15px;*/\r\n\tfont-size: 1.2rem;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-weight: 500;\r\n\tcolor: #333;\r\n\ttext-decoration: none;\r\n}\r\n\r\nheader .nav li a:hover {\r\n\tbackground: transparent !important;\r\n}\r\n\r\nheader .nav .open > a, header .nav .open > a:hover, header.nav .open > a:focus, header.nav .open > a:visited {\r\n\tbackground: transparent !important;\r\n\tborder: 0px;\r\n}\r\n\r\nheader .nav .dropdown .dropdown-menu a {\r\n\tfont-weight: 400;\r\n}\r\n\r\nheader .nav .dropdown .dropdown-menu a:hover {\r\n\tbackground: var(--main-primary) !important;\r\n\tcolor: #fff;\r\n}\r\n\r\nheader .navbar-nav li a i {\r\n\tfont-size: 16px;\r\n\tfont-size: 1.6rem;\r\n}\r\n\r\n/*header .header-menu li a:hover {\r\n    color: #799f2c;\r\n}\r\n\r\nheader .header-menu i {\r\n    font-size: 24px;\r\n}*/\r\n\t\r\n\r\n\r\n@media (max-width: 1200px) {\r\n\t.navbar-nav { \r\n\t\tmargin-top: -6px;\r\n\t}\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
